import Mustache from 'mustache'

/**
 * PDF list custom element
 */
class PDFList {
  constructor() {
    this.el = null
    this.elContent = null
    this.templateItem = document.querySelector('#js-pdf-list-template-item')?.innerHTML
    this.showMore = document.querySelector('.js-pdf-list-show-more')
    this.params = {
      pdfAmount: 10,
      pdfLoadMoreAmount: 2,
      from: 0,
    }
    this.ajaxURL = '/stage-ajax/getPDFList'
  }

  /**
   * Initialize
   * @param {String} el element of pdf list
   */
  init(el) {
    if (el) {
      if (document.querySelector(el) && this.templateItem) {
        this.el = document.querySelector(el)
        this.params = {
          ...this.params,
          ...this.el.dataset,
          pdfLoadMoreAmount: Number(this.el.dataset.pdfLoadMoreAmount),
          from: Number(this.params.from),
        }
        this.elContent = this.el?.querySelector('.js-pdf-list-content')
        this.fetchData()
        this.showMore?.addEventListener('click', (e) => {
          e.preventDefault()
          this.fetchData()
        })
      }
    }
  }

  /**
   * Fetch data from ajax function
   */
  fetchData() {
    fetch(`${this.ajaxURL}?${new URLSearchParams(this.params).toString()}`, {
      method: 'GET',
    }).then(data => data.json()).then(res => {
      this.render(res)
      this.params.from += res.items.length
      if (res.count > this.params.from) {
        this.showMore.classList.remove('hidden')
      } else {
        this.showMore.classList.add('hidden')
      }
    })
  }

  /**
   * Render HTML to page with mustache
   * @param {Object} data All data from ajax function
   */
  render(data) {
    data.items = data.items.map(item => {
      return {
        ...item,
        date: new Date(item.publish_date).toLocaleDateString('fi-FI', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        })
      }
    })
    this.elContent.innerHTML += Mustache.render(this.templateItem, data)
  }
}

export default new PDFList()
